/** @jsx jsx */
import { Elevation } from '@blueprintjs/core';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import AttendListItem from '../../../components/AttendListItem';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import PaginatedTable from '../../../components/PaginatedTable';
import PaginationBar from '../../../components/PaginationBar';
import { useSoulAttendsQuery } from '../../../generated/graphql';
import { dummyAttends } from '../../matching/dummy';

const SoulAttends = () => {
  const [attendPage, setAttendPage] = useState(1);
  const { soulId } = useParams();

  const { data, loading, error } = useSoulAttendsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: soulId || '',
      first: 10,
      page: attendPage,
    },
  });

  const { data: attends, paginatorInfo } = data?.soul?.attends || {};
  const { currentPage, lastPage, hasMorePages } = paginatorInfo || {};

  return (
    <ContentCard elevation={Elevation.TWO} css={styles.spacedCard}>
      <ContentCardHeader
        leftElement={
          <Fragment>
            <span css={styles.heading}>Teilnahmen</span>
          </Fragment>
        }
      />
      <PaginatedTable
        columns={['Veranstaltung', 'Begleitung', 'Zeitpunkt']}
        interactive
        loading={loading}
        hasError={!!error}
        empty={!attends?.length}
      >
        {(loading ? dummyAttends : attends || []).map((attend) => (
          <AttendListItem key={attend.id} attend={attend} skeleton={loading} />
        ))}
      </PaginatedTable>
      <PaginationBar
        loading={loading}
        empty={!attends?.length}
        currentPage={currentPage}
        lastPage={lastPage}
        hasMorePages={hasMorePages}
        onPrev={() => setAttendPage(currentPage && currentPage > 0 ? currentPage - 1 : 1)}
        onNext={() => setAttendPage(currentPage ? currentPage + 1 : 1)}
      />
    </ContentCard>
  );
};

export default SoulAttends;

const styles = {
  heading: css`
    font-size: 16px;
  `,
  spacedCard: css`
    margin-bottom: 20px;
  `,
};
